// top-level imports
import React from 'react';
// antd
import Modal from 'antd/lib/modal';
// APOLLO
import { graphql } from 'react-apollo';
import createSupportMessage from 'ApolloClient/Mutations/createSupportMessage';
// MODULES
import HelpForm from 'components/forms/HelpForm';

// CONSTANTS & DESTRUCTURING
// ====================================

// EXPORTED COMPONENT
// ===================================

class HelpModal extends React.Component {
  state = { visible: false };

  render() {
    const { helpModalOpen, togglehelpModal } = this.props;

    return (
      <div style={{ display: 'inline' }}>
        <Modal
          title="Contact CClariti with Questions or Feedback"
          visible={helpModalOpen}
          onOk={() => togglehelpModal(helpModalOpen)}
          onCancel={() => togglehelpModal(helpModalOpen)}
          footer={null}
          className="confirm-modal"
        >
          <HelpForm
            handleCancel={() => togglehelpModal(helpModalOpen)}
            createSupportMessage={this.props.createSupportMessage}
          />
        </Modal>
      </div>
    );
  }
}

export default graphql(createSupportMessage, { name: 'createSupportMessage' })(HelpModal);



// WEBPACK FOOTER //
// ./src/components/common/HelpModal/index.js